import React, { useEffect, useState } from "react";
import Button from "../Button/Button.component";
import styles from "./CookiesBanner.module.scss";
import GAService from "../../services/ga.service";
import { FLARE_SPACE_DOMAIN, COOKIE_CONNECT_WALLET } from "../../constants";
import { CookieService } from "../../services/cookie.service";

const CookiesBanner: React.FC = () => {
  const [accepted, setAccepted] = useState(false);

  const acceptCookies = () => {
    if (process.env.REACT_APP_DEPLOY_TARGET === "production") {
      GAService.loadGoogleAnalytics();
    }
    // COOKIE_CONNECT_WALLET is used accross Flare.space to detect if cookies are enabled
    CookieService.setCookie(COOKIE_CONNECT_WALLET, true);
    setAccepted(true);
  };

  /**
   * Check if GA cookie with the tracking id is already set.
   */

  useEffect(() => {
    setAccepted(CookieService.cookieExists(COOKIE_CONNECT_WALLET));
  }, []);

  if (!accepted) {
    return (
      <div className={styles.banner}>
        <p>
          The website uses cookies for a variety of purposes. Some are essential
          for the operation of online services. However, cookies for analytics
          and your settings provide a better user experience, easier site usage.
          You can read more about cookies in Cookies. By continuing to use the
          site you agree to the{" "}
          <a href={`${FLARE_SPACE_DOMAIN}/privacy#cookies`}>cookies</a>. You can
          edit your cookie{" "}
          <a href={`${FLARE_SPACE_DOMAIN}/privacy#settings`}>settings here</a>.
        </p>
        <div className={styles.buttonWrapper}>
          <Button
            addStyles={["full", "narrow", "morePadding"]}
            onClick={() => acceptCookies()}
          >
            OK
          </Button>
        </div>
      </div>
    );
  } else {
    return <></>;
  }
};

export default CookiesBanner;
